import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK_REVIEWS = [
  { name: "Laura M.", device: "iPhone 13", text: "Mein eingeschicktes Gerät kam nach 2 Tagen repariert zurück – ich bin absolut begeistert. Ehrliche Beratung und fairer Preis." },
  { name: "Deniz K.", device: "iPhone 12 Pro", text: "Akku war nach zwei Jahren durch. Jetzt hält er wieder den ganzen Tag. Schnell und unkompliziert." },
  { name: "Sarah B.", device: "iPhone 14", text: "Endlich ein Laden, der nur iPhones macht und weiß, was er tut. Komme nie wieder woanders hin." },
];

export default function Testimonials() {
  const [reviews, setReviews] = useState(FALLBACK_REVIEWS);

  useEffect(() => {
    api.get("/content").then((r) => {
      if (r.data?.testimonials?.length) setReviews(r.data.testimonials);
    }).catch(() => {});
  }, []);

  return (
    <section id="stimmen" data-testid="testimonials" className="relative z-10 bg-[#0a0a0a] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-14">
          <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-xl">
            Kunden, die wieder strahlen.
          </h2>
          <span className="hidden sm:block font-mono text-sm text-[#888]">★ 4,9 / 5</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              className="rounded-3xl border border-white/10 bg-[#050505] p-8 flex flex-col justify-between min-h-[280px]"
            >
              <div className="flex items-center gap-0.5" data-testid={`testimonial-rating-${i}`}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} size={14} className="text-amber-400" fill={n <= (r.rating || 5) ? "currentColor" : "none"} />
                ))}
              </div>
              <p className="font-display text-2xl text-white/90 leading-snug mt-4">“{r.text}”</p>
              <div className="mt-8">
                <p className="text-white text-sm">{r.name}</p>
                <p className="font-mono text-xs text-[#888] mt-1">{r.device}</p>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
